module.exports = "/images/vendor/flag-icon-css/flags/4x3/gm.svg?50fe2799b099599b89f80b4d25376134";